const POLLING_INTERVAL = 3000

export const pollImage = (src: string, onPollSuccess: () => void) => {
  let image: HTMLImageElement
  let timeout: NodeJS.Timeout
  let onLoadSuccess: () => void
  let onLoadError: () => void

  const startPoll = (): void => {
    if (image) {
      image.removeEventListener('load', onLoadSuccess)
      image.removeEventListener('error', onLoadError)
    }
    image = new Image()
    image.addEventListener('load', onLoadSuccess)
    image.addEventListener('error', onLoadError)
    clearTimeout(timeout)
    image.src = src
  }

  onLoadSuccess = () => {
    onPollSuccess()
  }

  onLoadError = () => {
    timeout = setTimeout(startPoll, POLLING_INTERVAL)
  }

  startPoll()

  return {
    cancel(): void {
      clearTimeout(timeout)
      if (image) {
        image.src = '' // cancel loading (https://stackoverflow.com/a/527838/10340502)
        image.removeEventListener('load', onLoadSuccess)
        image.removeEventListener('error', onLoadError)
      }
    },
  }
}
